import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { LungVolumeAnalysisListScreen } from "./LungVolumeAnalysisListScreen";
import { LungVolumeSessionsListScreen } from "./LungVolumeSessionsListScreen";
import { LungVolumeAnalysisScreen } from "./LungVolumeAnalysisScreen";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { SearchParams } from "../../Components/Query";

export const LungVolumeRoot = () => {
    const [analysisSetListQuery, setAnalysisSetListQuery] = React.useState<SearchParams>();

    return (
        <Routes>
            <Route index element={
               <PrivateRoute permissions={[PermissionEnum.AccessSingleLungVolumeSession, PermissionEnum.AccessAllLungVolumeSessions, PermissionEnum.OverreadLungVolumeSession]}>
                <LungVolumeSessionsListScreen />
                </PrivateRoute>
            }
            />
            <Route path="Analysis" element={
               <PrivateRoute permissions={[PermissionEnum.OverreadLungVolumeSession]}>
                <LungVolumeAnalysisListScreen cachedQuery={analysisSetListQuery} setCachedQuery={setAnalysisSetListQuery} />
                </PrivateRoute>
            }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadLungVolumeSession, PermissionEnum.AccessSingleLungVolumeSession]}>
                <LungVolumeAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
